import React from 'react';
import './style.scss';
import clsx from 'clsx';
import icons from '../../../../../../common/Icons';

const CardsListCardRewardsButton = ({ opened, setOpened }) => {
  const handleOpenClick = () => {
    if (setOpened) setOpened();
  };

  return (
    <div
      className={clsx(
        'cards-list-card-rewards-button',
        opened && 'cards-list-card-rewards-button-opened'
      )}
    >
      <div className="clcrb-highlight-line" />
      <div className="clcrb-open-button" onClick={handleOpenClick}>
        <img src={icons.chevronDownThick} className="clcrb-open-button-open" />
        <img src={icons.chevronUpThick} className="clcrb-open-button-close" />
      </div>
    </div>
  );
};

export default CardsListCardRewardsButton;
